import {
  invoiceConfigByCode,
  invoiceControlConfigByCode,
  outsourceInvoiceConfigByCode,
  packageByStatus,
  projectInvoiceConfigByCode,
  quotationRequestConfigByCode,
} from '../invoice/utils';
import {
  issueStatusesByCode,
  projectStatusByCode,
  recruitmentStatusByCode,
  taskStatusByCode,
} from '../configs';
import { bugReportByCode, suggestionByCode } from '../feedback/utils';

const configs = {
  project: projectStatusByCode,
  task: taskStatusByCode,
  subTask: taskStatusByCode,
  issues: issueStatusesByCode,

  invoiceControl: invoiceControlConfigByCode,
  projectInvoice: projectInvoiceConfigByCode,
  quotationRequest: quotationRequestConfigByCode,
  invoice: invoiceConfigByCode,
  package: packageByStatus,

  outsourceInvoice: outsourceInvoiceConfigByCode,

  recruitments: recruitmentStatusByCode,

  userSuggestion: suggestionByCode,
  bugReport: bugReportByCode,
};

type Config = typeof configs;

export function getStatusConfig<Target extends keyof Config>(
  target: Target,
  statusRef: string | { status: string },
): Config[Target][string] {
  const status = typeof statusRef === 'string' ? statusRef : statusRef.status;

  return configs[target][status] as Config[Target][string];
}
